import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

export const Route = createFileRoute("/_staff/person/$id/_profile/equipment/")({
  component: () => <ComingSoonCover />,
});
